// Curated directory catalog. Each entry deep-links to the "Add a business" form
// so the admin fills it in one paste-heavy pass, then marks as submitted.

export const DIRECTORIES = [
  {
    slug: "google-business",
    name: "Google Business Profile",
    tier: "Tier 1 — Essential",
    submitUrl: "https://business.google.com/create",
    manageUrl: "https://business.google.com/",
    notes: "Highest-leverage listing. Verify by phone or postcard. Feeds Google Maps, Search, and Assistant.",
    typicalTimeMin: 15,
  },
  {
    slug: "bing-places",
    name: "Bing Places for Business",
    tier: "Tier 1 — Essential",
    submitUrl: "https://www.bingplaces.com/",
    manageUrl: "https://www.bingplaces.com/",
    notes: "Feeds Bing, Yahoo, DuckDuckGo, and — critically — ChatGPT's web search grounding.",
    typicalTimeMin: 8,
  },
  {
    slug: "apple-business-connect",
    name: "Apple Business Connect",
    tier: "Tier 1 — Essential",
    submitUrl: "https://businessconnect.apple.com/",
    manageUrl: "https://businessconnect.apple.com/",
    notes: "Powers Apple Maps and Siri answers. Verification by ID or business documents.",
    typicalTimeMin: 12,
  },
  {
    slug: "justdial",
    name: "JustDial",
    tier: "Tier 2 — India directories",
    submitUrl: "https://www.justdial.com/free-listing",
    manageUrl: "https://www.justdial.com/",
    notes: "India's largest local directory. Expect a sales call within 48h; free tier is enough.",
    typicalTimeMin: 5,
  },
  {
    slug: "sulekha",
    name: "Sulekha",
    tier: "Tier 2 — India directories",
    submitUrl: "https://www.sulekha.com/business/register",
    manageUrl: "https://www.sulekha.com/",
    notes: "Strong for services in NCR. Free listing tier available.",
    typicalTimeMin: 5,
  },
  {
    slug: "urbanpro",
    name: "UrbanPro (Services)",
    tier: "Tier 2 — India directories",
    submitUrl: "https://www.urbanpro.com/business-listing",
    manageUrl: "https://www.urbanpro.com/",
    notes: "Optional. Useful for reviews signal.",
    typicalTimeMin: 4,
  },
  {
    slug: "indiamart",
    name: "IndiaMART",
    tier: "Tier 2 — India directories",
    submitUrl: "https://seller.indiamart.com/",
    manageUrl: "https://seller.indiamart.com/",
    notes: "Mostly B2B — but LLMs scrape it heavily for Indian business data.",
    typicalTimeMin: 6,
  },
  {
    slug: "yelp",
    name: "Yelp",
    tier: "Tier 3 — Nice to have",
    submitUrl: "https://biz.yelp.com/signup",
    manageUrl: "https://biz.yelp.com/",
    notes: "Less used in India but often cited by Western LLMs.",
    typicalTimeMin: 4,
  },
  {
    slug: "trustpilot",
    name: "Trustpilot",
    tier: "Tier 3 — Nice to have",
    submitUrl: "https://business.trustpilot.com/",
    manageUrl: "https://business.trustpilot.com/",
    notes: "Review platform. LLMs weight Trustpilot mentions for credibility.",
    typicalTimeMin: 3,
  },
  {
    slug: "facebook-page",
    name: "Facebook Business Page",
    tier: "Tier 3 — Social presence",
    submitUrl: "https://www.facebook.com/pages/create",
    manageUrl: "https://business.facebook.com/",
    notes: "Also required to unlock Instagram Business + Meta ads.",
    typicalTimeMin: 5,
  },
  {
    slug: "instagram-business",
    name: "Instagram Business",
    tier: "Tier 3 — Social presence",
    submitUrl: "https://help.instagram.com/502981923235522",
    manageUrl: "https://business.instagram.com/",
    notes: "Convert to Business Account via app: Settings → Account → Switch to Professional.",
    typicalTimeMin: 3,
  },
  {
    slug: "linkedin-company",
    name: "LinkedIn Company Page",
    tier: "Tier 3 — Social presence",
    submitUrl: "https://www.linkedin.com/company/setup/new/",
    manageUrl: "https://www.linkedin.com/",
    notes: "Cited by GPT for B2B/hiring queries. Free.",
    typicalTimeMin: 4,
  },
];

export const TIER_LABELS = ["Tier 1 — Essential", "Tier 2 — India directories", "Tier 3 — Nice to have", "Tier 3 — Social presence"];
